import { render } from "./P040.vue?vue&type=template&id=557ee9ec&scoped=true"
import script from "./P040.vue?vue&type=script&lang=js"
export * from "./P040.vue?vue&type=script&lang=js"

import "./P040.vue?vue&type=style&index=0&id=557ee9ec&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-557ee9ec"]])

export default __exports__